import { Bell, CheckCheck } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";

const formatDate = (value) => {
  if (!value) return "";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleString();
};

export const NotificationCenter = ({ open, onClose, notifications, onOpenTask, onMarkRead }) => (
  <Dialog open={open} onOpenChange={onClose}>
    <DialogContent className="sm:max-w-2xl">
      <DialogHeader>
        <DialogTitle className="font-heading text-xl font-bold uppercase tracking-tight">Notifications</DialogTitle>
      </DialogHeader>
      <div className="mt-4 border border-zinc-200 max-h-[520px] overflow-y-auto divide-y divide-zinc-200">
        {notifications.length === 0 ? (
          <div className="p-8 text-sm text-zinc-400">No notifications right now.</div>
        ) : (
          notifications.map((notification) => (
            <div className={`p-4 ${notification.is_read ? "bg-white" : "bg-blue-50/50"}`} key={notification.id}>
              <div className="flex items-start justify-between gap-4">
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <Bell size={14} className="text-zinc-400" />
                    <p className="font-semibold text-zinc-900">{notification.title}</p>
                  </div>
                  <p className="mt-1 text-sm text-zinc-600">{notification.body}</p>
                  <p className="mt-2 text-xs text-zinc-400">{formatDate(notification.created_at)}</p>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  {notification.project_id ? (
                    <Button className="rounded-none border-zinc-300" onClick={() => onOpenTask(notification.project_id, notification.task_id || null)} size="sm" variant="outline">
                      Open
                    </Button>
                  ) : null}
                  {!notification.is_read ? (
                    <Button className="rounded-none border-zinc-300" onClick={() => onMarkRead(notification.id)} size="sm" variant="outline">
                      <CheckCheck size={14} className="mr-1" /> Read
                    </Button>
                  ) : null}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </DialogContent>
  </Dialog>
);
